import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, Subject, takeUntil } from 'rxjs';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';

import { OneTimePayFeatureFacade } from '../+state/one-time-pay-feature.facade';

@Injectable({
  providedIn: 'root'
})
export class OneTimePayBreadcrumbResolver implements OnDestroy {
  private stop$ = new Subject<void>();
  constructor(
    private featureflagService: FeatureFlagService,
    private oneTimePayFacade: OneTimePayFeatureFacade
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<string> | Promise<string> | string {
    return this.resolveBreadcrumb(route.data['resolveKey'], route);
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  private resolveBreadcrumb(key: string, _route: ActivatedRouteSnapshot): string {
    let breadcrumb = '';
    let isPhoenix;
    this.oneTimePayFacade
      .selectIsPhoenixPolicy()
      .pipe(
        map(data => data),
        takeUntil(this.stop$)
      )
      .subscribe(data => {
        isPhoenix = data;
      });
    const isPhoenixPaymentEnabled = this.featureflagService.isEnabled('one-time-pay-phoenix');
    switch (key) {
      case 'payment-review':
        breadcrumb = isPhoenixPaymentEnabled && isPhoenix ? 'Pay bills' : 'Payment Review';
        break;
      case 'payment-confirmation':
        breadcrumb = isPhoenixPaymentEnabled && isPhoenix ? 'none' : 'Payment Confirmation';
        break;
    }
    return breadcrumb;
  }
}
